import { render, staticRenderFns } from "./AssignCommitteeModal.vue?vue&type=template&id=36d178cc&scoped=true"
import script from "./AssignCommitteeModal.vue?vue&type=script&lang=js"
export * from "./AssignCommitteeModal.vue?vue&type=script&lang=js"
import style0 from "./AssignCommitteeModal.vue?vue&type=style&index=0&id=36d178cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d178cc",
  null
  
)

export default component.exports